
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_4c84z_1mgmb_93",
  "variant-secondary": "awsui_variant-secondary_4c84z_1mgmb_140",
  "variant-primary": "awsui_variant-primary_4c84z_1mgmb_177",
  "variant-info": "awsui_variant-info_4c84z_1mgmb_212",
  "variant-value-large": "awsui_variant-value-large_4c84z_1mgmb_249",
  "variant-top-navigation": "awsui_variant-top-navigation_4c84z_1mgmb_283",
  "variant-recovery": "awsui_variant-recovery_4c84z_1mgmb_318",
  "button": "awsui_button_4c84z_1mgmb_353",
  "color-inverted": "awsui_color-inverted_4c84z_1mgmb_390",
  "font-size-body-s": "awsui_font-size-body-s_4c84z_1mgmb_409",
  "font-size-body-m": "awsui_font-size-body-m_4c84z_1mgmb_414",
  "font-size-heading-xs": "awsui_font-size-heading-xs_4c84z_1mgmb_418",
  "font-size-heading-s": "awsui_font-size-heading-s_4c84z_1mgmb_422",
  "font-size-heading-m": "awsui_font-size-heading-m_4c84z_1mgmb_427",
  "font-size-heading-l": "awsui_font-size-heading-l_4c84z_1mgmb_432",
  "font-size-heading-xl": "awsui_font-size-heading-xl_4c84z_1mgmb_437",
  "font-size-display-l": "awsui_font-size-display-l_4c84z_1mgmb_442",
  "font-size-inherit": "awsui_font-size-inherit_4c84z_1mgmb_447",
  "icon-wrapper": "awsui_icon-wrapper_4c84z_1mgmb_453",
  "icon": "awsui_icon_4c84z_1mgmb_453"
};
  